import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  effect,
  inject,
  OnInit,
  signal,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MessagingStore } from '../../../../../data-access/src/index';
import { Message } from '../../../../../util/src/index';
import { MessageBubbleComponent, SenderType } from '../../../../../components/ui/src/index';
import { MessageContentPipe } from '../../../../../components/pipes/src/index';
import { MessagingDialogService } from '../../../../../components/services/src/index';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'messaging-message-thread',
  standalone: true,
  imports: [CommonModule, MessageContentPipe, MessageBubbleComponent],
  templateUrl: './message-thread.component.html',
  styleUrls: [
    '../../../../../../ui-components/src/lib/_styles/abstracts/_colors.scss',
    '../../../../../../ui-components/src/lib/_styles/abstracts/_typography.scss',
    '../../../../../../ui-components/src/lib/_styles/abstracts/_spacing.scss',
    './message-thread.component.scss',
  ],
  encapsulation: ViewEncapsulation.ShadowDom,
  providers: [],
})
export class MessageThreadComponent implements OnInit {
  private readonly store = inject(MessagingStore);
  private readonly dialogService = inject(MessagingDialogService);
  protected readonly messages = computed(() => this.store.patientMessages());
  protected readonly isLoading = computed(() => this.store.isLoading() && !this.hasInitialised());
  protected readonly hasUnread = computed(() => {
    const meta = this.store.patientMessagesMetadata();
    return meta ? meta.num_unread_from > 0 : false;
  });
  private readonly hasInitialised = signal(false);
  readonly patientId = computed(() => this.store.activePatientId() || 0);

  protected hideSystemMessages = false;

  constructor() {
    effect(() => {
      const patientId = this.store.activePatientId();
      if (patientId) {
        this.store.openPatientMessages(patientId);
      }
    });
  }

  ngOnInit() {
    this.store.startPolling();
    this.hasInitialised.set(true);
  }

  protected openChat() {
    const patientId = this.store.activePatientId();
    if (patientId) this.dialogService.openChat();
  }

  protected shouldHide(msg: Message): boolean {
    return this.hideSystemMessages && (msg.from.id === -1 || msg.from.firstname === null);
  }

  protected getSenderType(msg: Message): SenderType {
    const patientId = this.store.activePatientId();
    if (msg.from.id === -1 || msg.from.firstname === null) return 'system';
    if (msg.from.id === patientId) return 'patient';
    return 'doctor';
  }
}
